export enum VoicemailAnalyticsEvents {
  ExtensionFilterChanged = 'ext_fltr_chngd',
  UnreadFilterChanged = 'unrd_fltr_chngd',
  LinkCopied = 'link_copied',
  LinkCopiedAtTimestamp = 'link_copied_tmstmp',
  VoicemailDeleted = 'vm_dlt',
  VoicemailMarkedAsUnread = 'vm_unrd',
  VoicemailSelected = 'vm_slctd',
  VoicemailLoadError = 'vm_load_err',
  // Reliability signal (observability RFC): voicemail access success.
  VoicemailPlayed = 'voicemail_played',
  QuickActionCall = 'quick_action_c2c',
  QuickActionText = 'quick_action_text',
}
